import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../axiosInstance';
import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

function Changepassword() {
    const [formData, setFormData] = useState({
        current_password: '',
        new_password: '',
        confirm_password: ''
    });

    const [showPassword, setShowPassword] = useState({
        current_password: false,
        new_password: false,
        confirm_password: false
    });

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const id = localStorage.getItem('user_id');
    const username = localStorage.getItem('email');

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const togglePasswordVisibility = (field) => {
        setShowPassword(prev => ({ ...prev, [field]: !prev[field] }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        if (formData.new_password !== formData.confirm_password) {
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'New password and confirm password do not match!'
            });
            setLoading(false);
            return;
        }

        try {
            const payload = { ...formData, username };
            const response = await axiosInstance.put(`/auth/changepassword/${id}`, payload);

            Swal.fire({
                icon: 'success',
                title: 'Success!',
                text: response.data.message || 'Password updated successfully.'
            }).then(() => {
                localStorage.clear();
                navigate('/login');
            });

        } catch (err) {
            const message = err.response?.data?.error || 'An error occurred. Please try again.';
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: message
            });
        } finally {
            setLoading(false);
            setFormData({
                current_password: '',
                new_password: '',
                confirm_password: ''
            });
        }
    };

    return (
        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-3">
                        <div className="col-sm-6">
                            <h1 className="m-0">Change Password</h1>
                        </div>
                        <div className="col-sm-6 text-right">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item"><a href="/">Home</a></li>
                                <li className="breadcrumb-item active">Change Password</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-md-6">
                        <div className="card border-dark shadow-lg">
                            <div className="card-header bg-gradient-dark text-white">
                                <h4 className="mb-0"><i className="fas fa-key mr-2"></i>Update Your Password</h4>
                            </div>
                            <div className="card-body bg-light">
                                <form onSubmit={handleSubmit}>
                                    {['current_password', 'new_password', 'confirm_password'].map((field, index) => (
                                        <div className="form-group" key={index}>
                                            <label className="text-dark font-weight-bold">
                                                {field.replace('_', ' ').replace(/\b\w/g, c => c.toUpperCase())}
                                            </label>
                                            <div className="input-group">
                                                <input
                                                    type={showPassword[field] ? "text" : "password"}
                                                    name={field}
                                                    value={formData[field]}
                                                    onChange={handleChange}
                                                    className="form-control"
                                                    placeholder={`Enter ${field.replace('_', ' ')}`}
                                                    required
                                                />
                                                <div className="input-group-append">
                                                    <div className="input-group-text">
                                                        <span
                                                            className={`fas ${showPassword[field] ? 'fa-eye-slash' : 'fa-eye'}`}
                                                            style={{ cursor: 'pointer' }}
                                                            onClick={() => togglePasswordVisibility(field)}
                                                        ></span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}

                                    <div className="text-center">
                                        <button
                                            type="submit"
                                            className="btn btn-dark btn-block mt-3 font-weight-bold"
                                            disabled={loading}
                                        >
                                            {loading ? <><i className="fas fa-spinner fa-spin mr-2"></i>Updating...</> : 'Update Password'}
                                        </button>
                                    </div>
                                </form>
                            </div>
                            <div className="card-footer text-muted text-center">
                                Make sure to use a strong password to keep your account secure.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Changepassword;
